'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StoresQuadDownloadRu = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "#3DDC84",
                fillRule: "evenodd",
                d: "M34.116 4H21.87C16.118 4 14 6.11 14 11.875v12.246c0 5.766 2.11 7.876 7.875 7.876h12.246c5.766 0 7.879-2.11 7.879-7.876V11.875C41.99 6.11 39.882 4 34.116 4",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#C4D600",
                fillRule: "evenodd",
                d: "M34.116 4H21.87C16.118 4 14 6.11 14 11.875v12.246c0 5.766 2.11 7.876 7.875 7.876h12.246c5.766 0 7.879-2.11 7.879-7.876V11.875C41.99 6.11 39.882 4 34.116 4",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "m31.707 17.707-3 3a1 1 0 0 1-1.414 0l-3-3a.997.997 0 0 1 0-1.414 1 1 0 0 1 1.414 0L27 17.586V12a1 1 0 1 1 2 0v5.586l1.293-1.293a.999.999 0 1 1 1.414 1.414"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M20 22a1 1 0 1 1 2 0v1h12v-1a1 1 0 1 1 2 0v1a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2zM31.496 54v-6.341h1.327v2.847h.08l2.342-2.847h1.476l-2.311 2.777L36.884 54h-1.59l-1.842-2.694-.629.756V54zM25.882 54v-6.341h2.615c1.335 0 2.228.861 2.228 2.166v.009c0 1.305-.893 2.166-2.228 2.166h-1.288v2zm2.29-5.291h-.963v2.254h.962c.76 0 1.209-.404 1.209-1.125v-.008c0-.721-.448-1.121-1.209-1.121M19.244 54l2.201-6.341h1.56L25.211 54h-1.397l-.47-1.538h-2.237L20.637 54zm2.944-5.076-.778 2.545h1.63l-.773-2.545zM40.384 44v-4.838h1.283v1.406h.958c1.143 0 1.872.668 1.872 1.714v.009c0 1.041-.73 1.709-1.872 1.709zm2.017-2.465h-.734v1.498h.734c.488 0 .8-.307.8-.751v-.01c0-.443-.312-.737-.8-.737M39.836 39.162v.97H38.39V44h-1.283v-3.867h-1.45v-.971zM32.407 44.075c-.923 0-1.578-.572-1.578-1.45v-.01c0-.87.673-1.38 1.877-1.45l1.169-.07v-.4c0-.417-.286-.654-.813-.654-.462 0-.756.162-.857.448l-.01.017H31.01l.005-.04c.1-.847.9-1.41 2.118-1.41 1.283 0 2.008.607 2.008 1.64V44h-1.265v-.642h-.08c-.246.449-.755.717-1.388.717m-.325-1.53c0 .37.312.594.755.594.594 0 1.038-.391 1.038-.901v-.356l-.976.061c-.55.035-.817.242-.817.594zM30.172 44h-1.283v-1.894h-.08c-.254.206-.641.33-1.12.33-1.138 0-1.815-.695-1.815-1.793v-1.481h1.283v1.336c0 .575.286.874.857.874.418 0 .712-.114.875-.272v-1.938h1.283zM22.347 44.075c-.923 0-1.578-.572-1.578-1.45v-.01c0-.87.673-1.38 1.877-1.45l1.169-.07v-.4c0-.417-.286-.654-.813-.654-.462 0-.756.162-.857.448l-.01.017H20.95l.005-.04c.1-.847.9-1.41 2.118-1.41 1.283 0 2.008.607 2.008 1.64V44h-1.265v-.642h-.08c-.246.449-.755.717-1.388.717m-.325-1.53c0 .37.312.594.756.594.593 0 1.037-.391 1.037-.901v-.356l-.976.061c-.55.035-.817.242-.817.594zM17.743 41.974h-.246V44h-1.283v-4.838h1.283v1.898h.229l1.441-1.898h1.455l-1.837 2.215L20.718 44h-1.525zM12.726 44.163c-1.837 0-2.975-1.275-2.975-3.331v-.01c0-2.056 1.134-3.326 2.975-3.326 1.503 0 2.628.958 2.751 2.298v.053h-1.292v-.03c-.136-.712-.703-1.196-1.459-1.196-.997 0-1.617.84-1.617 2.202v.008c0 1.363.62 2.207 1.622 2.207.76 0 1.31-.444 1.45-1.121l.009-.035h1.292l-.005.048c-.136 1.327-1.221 2.233-2.75 2.233"
            })
        ]
    })));

export { StoresQuadDownloadRu, StoresQuadDownloadRu as default };
//# sourceMappingURL=StoresQuadDownloadRu.js.map
